import * as z from "zod";

/** Cutoffs in days after the original policy deadline; both are exclusive. */
export const AgentReturnWindowGraceSchema = z
  .object({
    agentGraceDays: z.number().int().nonnegative().safe(),
    merchantGraceDays: z.number().int().nonnegative().safe(),
  })
  .refine((value) => value.merchantGraceDays >= value.agentGraceDays, {
    message: "Merchant review cutoff must not precede the agent grace cutoff",
    path: ["merchantGraceDays"],
  });

export type AgentReturnWindowGrace = z.infer<
  typeof AgentReturnWindowGraceSchema
>;
